// extracted by css-extract-rspack-plugin
var _1 = "BTuOo_jtZsopyk5Z";
var _2 = "Z8wCrIgDCEodFxPx";
var _3 = "JDUAmCoQCFoHyJhg";
var _4 = "OiUKgeZFn6QBqasw";
var _5 = "EGSfpLPnwMwezD0N";
var _6 = "MnvQWvinCyMivQWl";
var _7 = "CjnZYD4S_48XGmS1";
var _8 = "cG6oRGo5AJATo7HM";
var _9 = "H6rthH0eoZkiiuod";
export { _1 as "message", _2 as "messageAction", _3 as "messageContent", _4 as "messageContentFailure", _5 as "messageFailure", _6 as "messageInfo", _7 as "messageNeutral", _8 as "messageSuccess", _9 as "messageWarning" }
